(() => {
  if (!customElements.get('carson-faq-accordion')) {
    class CarsonFaqAccordion extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.allowMultiple = this.dataset.accordionBehavior === 'multiple';
        this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.buttons = Array.from(this.querySelectorAll('[data-accordion-button]'));

        this.items.forEach((item) => {
          this.syncPanel(item);
        });

        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.toggleItem(this.items[index]));
          button.addEventListener('keydown', (event) => this.onButtonKeydown(event, index));
        });
      }

      syncPanel(item) {
        const button = item.querySelector('[data-accordion-button]');
        const panel = item.querySelector('[data-accordion-panel]');
        const isOpen = button?.getAttribute('aria-expanded') === 'true';

        if (!button || !panel) return;

        item.classList.toggle('is-open', isOpen);
        panel.hidden = !isOpen;
        panel.style.height = isOpen ? 'auto' : '0px';
        panel.style.opacity = isOpen ? '1' : '0';
      }

      toggleItem(item) {
        const button = item?.querySelector('[data-accordion-button]');
        const isOpen = button?.getAttribute('aria-expanded') === 'true';

        if (!item || !button) return;

        if (isOpen) {
          this.closeItem(item);
          return;
        }

        if (!this.allowMultiple) {
          this.items.forEach((otherItem) => {
            if (otherItem !== item) this.closeItem(otherItem);
          });
        }

        this.openItem(item);
      }

      openItem(item) {
        const button = item.querySelector('[data-accordion-button]');
        const panel = item.querySelector('[data-accordion-panel]');

        if (!button || !panel || button.getAttribute('aria-expanded') === 'true') return;

        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.style.height = '0px';
        panel.style.opacity = '0';

        requestAnimationFrame(() => {
          panel.style.height = `${panel.scrollHeight}px`;
          panel.style.opacity = '1';
        });

        panel.addEventListener(
          'transitionend',
          (event) => {
            if (event.propertyName === 'height' && button.getAttribute('aria-expanded') === 'true') {
              panel.style.height = 'auto';
            }
          },
          { once: true }
        );
      }

      closeItem(item) {
        const button = item.querySelector('[data-accordion-button]');
        const panel = item.querySelector('[data-accordion-panel]');

        if (!button || !panel || button.getAttribute('aria-expanded') === 'false') return;

        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        panel.hidden = false;
        panel.style.height = `${panel.scrollHeight}px`;
        panel.style.opacity = '1';

        requestAnimationFrame(() => {
          panel.style.height = '0px';
          panel.style.opacity = '0';
        });

        panel.addEventListener(
          'transitionend',
          (event) => {
            if (event.propertyName === 'height' && button.getAttribute('aria-expanded') === 'false') {
              panel.hidden = true;
            }
          },
          { once: true }
        );
      }

      onButtonKeydown(event, index) {
        const lastIndex = this.buttons.length - 1;
        let nextIndex = null;

        if (event.key === 'ArrowDown') nextIndex = index === lastIndex ? 0 : index + 1;
        if (event.key === 'ArrowUp') nextIndex = index === 0 ? lastIndex : index - 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = lastIndex;

        if (nextIndex === null) return;

        event.preventDefault();
        this.buttons[nextIndex]?.focus();
      }
    }

    customElements.define('carson-faq-accordion', CarsonFaqAccordion);
  }

  if (window.carsonFaqAccordionBlockSelectInitialized) return;

  window.carsonFaqAccordionBlockSelectInitialized = true;
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest?.('[data-accordion-item]');
    const accordion = item?.closest('carson-faq-accordion');

    if (item && accordion?.openItem) {
      if (!accordion.allowMultiple) {
        accordion.items.forEach((otherItem) => {
          if (otherItem !== item) accordion.closeItem(otherItem);
        });
      }
      accordion.openItem(item);
    }
  });
})();
